/* unplugin-vue-components disabled */import { render } from "./UserNickname.vue?vue&type=template&id=708f527a&scoped=true"
import script from "./UserNickname.vue?vue&type=script&lang=js"
export * from "./UserNickname.vue?vue&type=script&lang=js"

import "./UserNickname.vue?vue&type=style&index=0&id=708f527a&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgynew-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708f527a"]])

export default __exports__